<template>
  <div class="table-wrap">
    <el-table :data="tableData" border style="width: 100%" ref="table" id="rebateSetTable" :row-class-name="tableRowClassName">
      <el-table-column prop="type" label="预测方式" width="200" style="background: red"> </el-table-column>
      <el-table-column prop="formula" label="公式说明"> </el-table-column>
      <el-table-column prop="result" label="LT预测结果" class-name="lt-column" width="450">
        <template slot-scope="scope">
          <div class="green-back" v-if="scope.row.key === 1">{{ scope.row.result || "--" }}</div>
          <div v-else class="result-table green-back">
            <div class="result-item">
              <div class="lt-title" :class="{ 'entry-lt-title': isEntryData }">180LT：</div>
              <div class="lt-value">{{ isNaN(scope.row.lt180) ? "--" : scope.row.lt180 }}</div>
            </div>
            <div class="result-item">
              <div class="lt-title" :class="{ 'entry-lt-title': isEntryData }">360LT：</div>
              <div class="lt-value">{{ isNaN(scope.row.lt360) ? "--" : scope.row.lt360 }}</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column v-for="item in comlunData" :key="item.key" :prop="item.key" :label="item.label" width="100">
        <template slot-scope="scope">
          <span v-if="item.key === 'r2'"> {{ isNaN(scope.row[item.key]) ? "--" : scope.row[item.key] }}</span>
          <span v-else> {{ isNaN(scope.row[item.key]) ? "--" : scope.row[item.key] + "%" }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import XLSX from "xlsx";
import FileSaver from "file-saver";
export default {
  components: {},
  props: {
    dataObj: Object,
    isEntryData: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      comlunData: [
        { key: "r2", label: "R^2" },
        { key: "day1", label: "Day1" },
        { key: "day2", label: "Day2" },
        { key: "day3", label: "Day3" },
        { key: "day4", label: "Day4" },
        { key: "day5", label: "Day5" },
        { key: "day6", label: "Day6" },
        { key: "day7", label: "Day7" },
        { key: "day14", label: "Day14" },
        { key: "day30", label: "Day30" },
      ],
      tableData: [
        {
          key: 1,
          type: "经验公式",
          formula: "",
          result: "",
        },
        {
          key: 2,
          type: "幂函数（数据科学）",
          formula: "",
          result: "",
        },
        {
          key: 3,
          type: "幂函数（Excel）",
          formula: "",
          result: "",
        },
      ],
    };
  },

  computed: {},

  watch: {
    dataObj: {
      handler(val) {
        const { formula, lt360, lt180, r2, day1, day2, day3, day4, day5, day6, day7, day14, day30 } = val.powerFunctionPredict || {};
        this.tableData = [
          {
            key: 1,
            type: "经验公式",
            formula: val.classicPredict.formula,
            result: val.classicPredict.estimateTimes.toFixed(2),
          },
          {
            key: 2,
            type: "幂函数（数据科学）",
            formula,
            lt180: lt180?.toFixed(2),
            lt360: lt360?.toFixed(2),
            r2: r2?.toFixed(4),
            day1: (day1 * 100).toFixed(1),
            day2: (day2 * 100).toFixed(1),
            day3: (day3 * 100).toFixed(1),
            day4: (day4 * 100).toFixed(1),
            day5: (day5 * 100).toFixed(1),
            day6: (day6 * 100).toFixed(1),
            day7: (day7 * 100).toFixed(1),
            day14: (day14 * 100).toFixed(1),
            day30: (day30 * 100).toFixed(1),
          },
          {
            key: 3,
            type: "幂函数（Excel）",
            formula: val.functionPredict?.formula,
            lt180: val.functionPredict?.lt180.toFixed(2),
            lt360: val.functionPredict?.lt360.toFixed(2),
            r2: val.functionPredict?.r2.toFixed(4),
            day1: (val.functionPredict?.day1 * 100).toFixed(1),
            day2: (val.functionPredict?.day2 * 100).toFixed(1),
            day3: (val.functionPredict?.day3 * 100).toFixed(1),
            day4: (val.functionPredict?.day4 * 100).toFixed(1),
            day5: (val.functionPredict?.day5 * 100).toFixed(1),
            day6: (val.functionPredict?.day6 * 100).toFixed(1),
            day7: (val.functionPredict?.day7 * 100).toFixed(1),
            day14: (val.functionPredict?.day14 * 100).toFixed(1),
            day30: (val.functionPredict?.day30 * 100).toFixed(1),
          },
        ];
      },
      deep: true,
      // immediate: true,
    },
  },

  mounted() {},

  methods: {
    tableRowClassName() {
      if (this.isEntryData) {
        return "lt-entry-row";
      } else {
        return "";
      }
    },
    downLoadFileToExcel() {
      let fix = document.querySelector(".el-table__fixed");
      var xlsxParam = { raw: true }; //导出的内容只做解析，不进行格式转换(添加此行代码表格中的百分比就不会再导出的时候被转换成小数点)
      let wb;
      if (fix) {
        //判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去
        wb = XLSX.utils.table_to_book(document.querySelector("#rebateSetTable").removeChild(fix), xlsxParam);
        document.querySelector("#rebateSetTable").appendChild(fix);
      } else {
        wb = XLSX.utils.table_to_book(document.querySelector("#rebateSetTable"), xlsxParam);
      }
      let wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(new Blob([wbout], { type: "application/octet-stream" }), "LT预测表.xlsx");
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
  },
};
</script>

<style lang="less" scoped>
.table-wrap {
  margin: 0 20px;
  /deep/ .lt-column {
    padding: 0px !important;
    position: relative;
  }
  .result-table {
    display: flex;
    width: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    height: 100%;
    .green-back {
      background: red;
    }
    .result-item {
      display: flex;
      width: 50%;
      .lt-title {
        background: #fafafa;
        display: flex;
        align-items: center;
        width: 50%;
        justify-content: center;
      }
      .entry-lt-title {
        background: #d0eed5;
      }
      .lt-value {
        display: flex;
        width: 50%;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
/deep/ .el-table .lt-entry-row {
  .lt-column {
    background: #d0eed5;
  }
}
/deep/ .el-table--enable-row-hover .el-table__body .lt-entry-row:hover .lt-column {
  background: #d0eed5;
}
</style>
